import jQuery from "jquery";
(function (far, $) {
  far.alerts = {};

  //#region Public functions ====================================================

  far.alerts.initialize = function () {
    wireAlertCloseClick();
  };

  //#endregion

  //#region Private functions ===================================================

  function wireAlertCloseClick() {
    $(".js-close-alert").click(function (e) {
      e.preventDefault();
      $(this).parent().addClass("alert-closed");
    });
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
